import TextArea from "antd/es/input/TextArea";
import {forwardRef} from "react";
import type {InputRef} from "antd";
import type {AppTextAreaProps} from "./TextArea.types";

export const AppTextArea = forwardRef<InputRef, AppTextAreaProps>((props: AppTextAreaProps, ref) => {
  return <TextArea {...props} ref={ref}/>;
});